// ST-1258 -Claude- i18next bootstrap for nearrmeweb.
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {
  FALLBACK_LANGUAGE,
  type LanguageCode,
  SUPPORTED_LANGUAGE_CODES,
  isRtl,
  normalizeLanguageCode,
  resources,
} from '@nearrme/i18n';

export const LANGUAGE_STORAGE_KEY = 'nearrme.lang';

function getStoredLanguage() {
  if (typeof window === 'undefined') return undefined;

  return window.localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? undefined;
}

export function applyLanguageToDocument(
  ...languages: Array<string | null | undefined>
): LanguageCode {
  const languageCode = normalizeLanguageCode(...languages);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = languageCode;
    document.documentElement.dir = isRtl(languageCode) ? 'rtl' : 'ltr';
  }

  return languageCode;
}

export function persistLanguagePreference(language: string): LanguageCode {
  const languageCode = applyLanguageToDocument(language);

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, languageCode);
  }

  return languageCode;
}

const storedLanguage = getStoredLanguage();

export const i18nReady = i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources as any,
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGE_CODES,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    cleanCode: true,
    lng: storedLanguage ? normalizeLanguageCode(storedLanguage) : undefined,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: (language) => normalizeLanguageCode(language),
    },
  })
  .then((t) => {
    persistLanguagePreference(normalizeLanguageCode(i18next.language, i18next.resolvedLanguage));
    return t;
  });

export const i18n = i18next;
